// company kısmına yazılan değere göre fonksiyonlar değişebilir ör: "akar", "release"

export var company = "";
var appVersion = "25.11.5";

export const appInfo = () => {

  if (company == "akar") {
    return {
      title: 'mobiRoute',
      version: appVersion,
      apiURL: 'https://akar.fbsshop.de/api',
      imageServerURL: 'https://pay.mobiserver.de:4244',
      menu: "akar",
    };
  } if (company == "release") {
    return {
      title: 'mobiRoute',
      version: appVersion,
      apiURL: 'https://api.fbsshop.de',
      imageServerURL: 'https://image.mobiapi.de',
      menu: "release",
    }
  }
  else {
    return {
      title: 'mobiRoute',
      version: appVersion,
      apiURL: 'https://api.fbsshop.de',
      imageServerURL: 'https://image.mobiapi.de',
      menu: "",
    };
  }
}